import { render, staticRenderFns } from "./PrivacyPage.vue?vue&type=template&id=177730de&scoped=true&"
import script from "./PrivacyPage.vue?vue&type=script&lang=js&"
export * from "./PrivacyPage.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPage.vue?vue&type=style&index=0&id=177730de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.registry.npmjs.org/vue-loader/15.9.7_css-loader@3.6.0+webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177730de",
  null
  
)

export default component.exports